import { render, staticRenderFns } from "./BasalMetabolicRate.vue?vue&type=template&id=5dab9c1c&scoped=true&"
import script from "./BasalMetabolicRate.vue?vue&type=script&lang=js&"
export * from "./BasalMetabolicRate.vue?vue&type=script&lang=js&"
import style0 from "./BasalMetabolicRate.vue?vue&type=style&index=0&id=5dab9c1c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dab9c1c",
  null
  
)

export default component.exports